<template>
	<IconBase icon-name="undo">
		<path d="m 12,4 v 6 l -4,-3 z" class="blueFill blueStroke" />
		<path d="m 12,7 a 6,6 0 0 1 5.5,3.7 6,6 0 0 1 -1.3,6.5 6,6 0 0 1 -6.5,1.3 6,6 0 0 1 -3.7,-5.5" class="blueStroke" />
	</IconBase>
</template>

<script>
import IconBase from './IconBase';
export default {
	components: {
		IconBase
	}
};
</script>
